module.exports = __webpack_public_path__ + "media/images/footer_background_image-989c42f619608a3d2293ed423d162401.jpeg";